export default __webpack_public_path__ + "static/img/bike.355bfd5.png";